export const GET_CANCEL_BY_DATE_REQUEST =
    "GET_CANCEL_BY_DATE_REQUEST";

export const GET_CANCEL_BY_DATE_SUCCESS =
    "GET_CANCEL_BY_DATE_SUCCESS";

export const GET_CANCEL_BY_DATE_FAILURE =
    "GET_CANCEL_BY_DATE_FAILURE";

export const getCancelByDateRequest = (
    branchid: string,
    fromdate: string,
    todate: string
) => ({
    type: GET_CANCEL_BY_DATE_REQUEST,
    payload: {
        branchid,
        fromdate,
        todate,
    },
});

// Update to New Booking 
export const UPDATE_TO_NEW_BOOKING_REQUEST = "UPDATE_TO_NEW_BOOKING_REQUEST";
export const UPDATE_TO_NEW_BOOKING_SUCCESS = "UPDATE_TO_NEW_BOOKING_SUCCESS";
export const UPDATE_TO_NEW_BOOKING_FAILURE = "UPDATE_TO_NEW_BOOKING_FAILURE";
export const RESET_UPDATE_TO_NEW_BOOKING = "RESET_UPDATE_TO_NEW_BOOKING";

export const updateToNewBookingRequest = (payload: { bookid: number; updatedBy: string }) => ({
    type: UPDATE_TO_NEW_BOOKING_REQUEST,
    payload,
});

export const updateToNewBookingSuccess = (data: {
    status: number;
    message: string;
}) => ({
    type: UPDATE_TO_NEW_BOOKING_SUCCESS,
    payload: data,
});

export const updateToNewBookingFailure = (error: string) => ({
    type: UPDATE_TO_NEW_BOOKING_FAILURE,
    payload: error,
});

export const resetUpdateToNewBooking = () => ({
    type: RESET_UPDATE_TO_NEW_BOOKING,
});